import React, { useState, useEffect, useCallback } from 'react'
import { useParams } from 'react-router-dom'
import {
  requestCustomerInfo,
  requestCustomerUpdate,
} from 'requests/customers'
import { customerInfo } from 'config/submenus/customer'
import { InfoPage } from 'templates/InfoPage'
import { Form } from 'components/Customer/Form'
import { SideMenu } from 'components/SideMenu'
import { ApiErrors } from 'ui-components/ApiErrors'
import { SlideDialog } from 'ui-components/SlideDialog'
import { BasicInfo } from './components/BasicInfo'
import { AddressInfo } from './components/AddressInfo'
import { TelephoneInfo } from './components/TelephoneInfo'
import { InfoCards, InfoCard } from './styles'

export default function CustomerInfo() {
  const [customer, setCustomer] = useState()
  const [loading, setLoading] = useState(true)
  const [responseError, setResponseError] = useState()
  const [toEditCustomer, setToEditCustomer] = useState(false)
  const [saving, setSaving] = useState(false)
  const [savingAddress, setSavingAddress] = useState(false)
  const [savingPhones, setSavingPhones] = useState(false)

  const { id } = useParams()

  const getCustomer = useCallback(async () => {
    setLoading(true)
    const response = await requestCustomerInfo(id)

    setLoading(false)
    if (response.error) return setResponseError(response)

    return setCustomer(response.data)
  }, [id])

  useEffect(() => {
    getCustomer()
  }, [getCustomer])

  const onCancelEdit = () => {
    setToEditCustomer(false)
    setResponseError({})
  }

  const onSave = async (params) => {
    setResponseError({})
    const response = await requestCustomerUpdate(customer.id, params)

    setSaving(false)
    setSavingAddress(false)
    setSavingPhones(false)
    if (response.error) return setResponseError(response)

    setToEditCustomer(false)
    return setCustomer({ ...response.data })
  }

  const onSaveCustomer = (params) => {
    setSaving(true)
    onSave(params)
  }

  const onSaveAddress = (address) => {
    setSavingAddress(true)
    const params = {
      customer: {
        addresses: [address],
      },
    }

    onSave(params)
  }

  const onSaveTelephones = (telephones) => {
    setSavingPhones(true)
    const params = {
      customer: {
        telephones,
      },
    }

    onSave(params)
  }

  const renderLoading = () => (
    <div>Loading...</div>
  )

  const renderErrorMessage = () => (
    <ApiErrors responseError={responseError} />
  )

  const renderCustomer = () => (
    <InfoCards>
      <BasicInfo customer={customer} />
      <div>
        <InfoCard>
          <AddressInfo
            addresses={customer.attributes?.addresses}
            saving={savingAddress}
            responseError={responseError}
            onSave={onSaveAddress}
          />
        </InfoCard>
        <InfoCard>
          <TelephoneInfo
            telephones={customer.attributes?.telephones}
            saving={savingPhones}
            responseError={responseError}
            onSave={onSaveTelephones}
          />
        </InfoCard>
      </div>
    </InfoCards>
  )

  const renderMenu = () => (
    <SideMenu submenu={customerInfo(customer?.id)} />
  )

  return customer?.id ? (
    <InfoPage
      renderMenu={renderMenu}
      title={customer.attributes.name}
      subtitle="Informações do cliente"
      onEdit={() => setToEditCustomer(true)}
    >
      <SlideDialog
        open={toEditCustomer}
        onClose={() => setToEditCustomer(false)}
      >
        <Form
          customer={customer}
          onCancel={onCancelEdit}
          onSave={onSaveCustomer}
          responseError={responseError}
          saving={saving}
        />
      </SlideDialog>

      { renderErrorMessage() }
      { renderCustomer() }
      { loading ? renderLoading() : null }
    </InfoPage>
  ) : null
}
